export default "__VITE_ASSET__fdc6b8e8__"